export default __webpack_public_path__ + "static/media/@eu.kaholiveira.f2c5eb82.jpg";